export const CREATE_PASSENGER = "CREATE_PASSENGER";
export const UPDATE_PASSENGER = "UPDATE_PASSENGER";
